import React from 'react';

import { Text } from '@/components/shared/element/text';
import { styled } from '@/stitches.config';
import { IMy24Theme } from '@/types/shared';
import { ITest } from '@/types/tracking';

interface IProps {
  theme?: IMy24Theme;
  children?: React.ReactNode;
  for?: string;
  required?: boolean;
  test?: ITest;
  variant?: 'black' | 'white';
}

const StyledLabel = styled('label', {});

export const Label = (props: IProps) => {
  const textVariant = () => {
    switch (props.variant) {
      case 'black':
        return 'text-black';
      case 'white':
        return 'text-white';
      default:
        return 'text-black';
    }
  };

  return (
    <StyledLabel
      htmlFor={props.for}
      data-test={props.test ? props.test?.dataTest : null}
    >
      <Text size="base" variant={textVariant()}>
        {props.children}
        {!!props.required && (
          <Text
            size="base"
            variant="text-red"
            css={{ display: 'inline-block', ml: 2, us: 'none' }}
          >
            *
          </Text>
        )}
      </Text>
    </StyledLabel>
  );
};
Label.displayName = 'SharedFormLabel';
